import React from 'react';

function Modal({ children, onClose, closeOnMaskClick = true }) {
  let onMaskClick = () => {};

  if (closeOnMaskClick) {
    onMaskClick = onClose;
  }

  return (
    <div className="modal-bg ad-padding" onClick={onMaskClick}>
      <div className="modal-wrapper">
        <div
          className="modal-close-button"
          onClick={(e) => {
            onClose();
            e.stopPropagation();
          }}
        >
          <span className="material-symbols-rounded">close</span>
        </div>
        <div
          className="modal"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
